'use client';

import { TypographyV3 } from '@jouzen/ecom-components';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { redirect } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

import useDiscountPage from '@/app/hooks/useDiscountPage';

const DiscountPage = ({
  handle,
}: {
  readonly handle: string | null | undefined;
}): JSX.Element => {
  const { redirectUrl, isReady } = useDiscountPage(handle);
  const t = useTranslations();

  useEffect(() => {
    if (isReady) {
      redirect(redirectUrl);
    }
  }, [isReady, redirectUrl]);

  return (
    // eslint-disable-next-line tailwindcss/no-custom-classname -- required for styles below to work
    <div className="tailwind">
      <Backdrop open className="z-50 bg-sandstone-100 text-sandstone-500">
        <div className="flex justify-center gap-4">
          <CircularProgress color="inherit" size={20} />
          <TypographyV3>{t('loading')}</TypographyV3>
        </div>
      </Backdrop>
    </div>
  );
};

export default DiscountPage;
